import { Activity, ArrowUpDown, Heart, Brain, Footprints, Building2, Target } from "lucide-react";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const iconMap = {
  Spine: Activity,
  Activity: Activity,
  ArrowUpDown: ArrowUpDown,
  Heart: Heart,
  Brain: Brain,
  Footprints: Footprints,
  Building2: Building2,
  Target: Target
};

export const LEGAL_INFO = {
  company: "ИП Гамбаров Михаил Георгиевич",
  inn: "772864058362",
  ogrnip: "326774600260550",
  email: "info@kosslab.ru",
  site: "kosslab.ru"
};
